// @flow

import type {PureAction} from '@travel-frontend/state-handling-sdk';

import {PURE} from '@travel-frontend/state-handling-sdk';

export const SET_NO_OPTION_SELECTCED =
  'uiState/insurance/SET_NO_OPTION_SELECTED';
export const REMOVE_NO_OPTION_SELECTED =
  'uiState/insurance/REMOVE_NO_CHOICE_SELECTED';
export const SET_TO_CHECKED = 'uiState/insurance/SET_NO_OPTION_SELECTED';

export const setNoOptionSelected = (): PureAction => {
  return {
    type: PURE(SET_NO_OPTION_SELECTCED),
  };
};

export const removeNoOptionSelected = (): PureAction => {
  return {
    type: PURE(REMOVE_NO_OPTION_SELECTED),
  };
};

export const setToChecked = (): PureAction => {
  return {
    type: PURE(SET_TO_CHECKED),
  };
};
